<template>
  <component :is="computedComponent" />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { IconName, iconNames, icons } from './icons'

export default defineComponent({
  name: 'KIcon',
  props: {
    name: {
      type: String as () => IconName,
      required: true,
      validator: (value: string): boolean => iconNames.includes(value)
    }
  },
  setup (props) {
    const computedComponent = computed(() => (icons as any)[props.name])
    return { computedComponent }
  }
})
</script>
